import React, { useEffect, useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { CommonClasses } from "../../global/GlobalStyle";

const DarkModeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(false);

  // On mount, set theme based on localStorage or system preference
  useEffect(() => {
    const storedTheme = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;

    if (storedTheme === "dark" || (!storedTheme && prefersDark)) {
      document.documentElement.classList.add("dark");
      setIsDarkMode(true);
    } else {
      document.documentElement.classList.remove("dark");
      setIsDarkMode(false);
    }
  }, []);

  // Toggle function
  const toggleDarkMode = () => {
    const newMode = !isDarkMode;
    setIsDarkMode(newMode);

    if (newMode) {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  };

  // Keep your exact icon style logic
  const MoonIcon = FaMoon as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
  const SunIcon = FaSun as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

  return (
    <button
      className={`${CommonClasses.flexCenter} transition-all duration-300`}
      onClick={toggleDarkMode}
    >
      {isDarkMode ? (
        <SunIcon className="w-5 h-5 text-primary" />
      ) : (
        <MoonIcon className="w-5 h-5 text-secondary" />
      )}
    </button>
  );
};

export default DarkModeToggle;
